import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorNameTextFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorNameTextField: FC<CryptorNameTextFieldProps> = ({ control }) => {
  return (
    <Controller
      control={control}
      name="name"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Nom"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorNameTextField;
